export interface SelectOption {
  label: string;
  value: string;
}

export interface CatalogOption {
  id: string;
  label: string;
}

export function mapCatalogOptionsToSelectOptions(items: CatalogOption[]): SelectOption[] {
  return items.map((item) => ({
    label: item.label,
    value: item.id,
  }));
}
